<app-complete-order-container
  [offerReference]="viewOffersService.offerReference$ | async"
  [deliveryAddress]="viewOffersService.deliveryAddress$ | async"
  [itemOffer]="additionalServicesService.itemOffer$ | async"
  [offerStatus]="(viewOffersService.offers$ | async).offer?.offer_status"
  [contact]="(viewOffersService.offers$ | async).contact_details"
></app-complete-order-container>
